// @ts-nocheck
import React, { useCallback, useMemo } from 'react';
import { ReactComponent as CircleIcon } from '../../../assets/Icons/lucideIcons/circle.svg';
import { Tooltip, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { ALERT_LABEL } from '../../../const/CommonConst';

/** @param {{ flag: string, iconSize?: string }} props */
const AlertHealthIndicator = ({ flag, iconSize }) => {
  const theme = useTheme();
  const alertLabel = useMemo(() => {
    return /** @type {Record<string, string>} */ (ALERT_LABEL)[flag] || flag;
  }, [flag]);

  const getAlertFlagColor = useCallback(() => {
    switch (flag) {
      case 'Low':
        return theme?.palette?.examinationResults?.severityLow;
      case 'Medium':
        return theme?.palette?.examinationResults?.severityMedium;
      case 'High':
        return theme?.palette?.examinationResults?.severityHigh;
      default:
        return theme?.palette?.text?.primary;
    }
  }, [flag, theme]);

  const color = getAlertFlagColor();
  const size = iconSize ? parseInt(iconSize, 10) : 18;

  return (
    <Tooltip title={`${alertLabel}. Click to view overdue alerts`}>
      <CircleIcon
        style={{
          color,
          fill: color,
          stroke: color,
        }}
        width={size}
        height={size}
      />
    </Tooltip>
  );
};
AlertHealthIndicator.propTypes = {
  flag: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
};

export default AlertHealthIndicator;
